import { render } from "./StudentMessagesBlock.vue?vue&type=template&id=667e362f&scoped=true"
import script from "./StudentMessagesBlock.vue?vue&type=script&lang=js"
export * from "./StudentMessagesBlock.vue?vue&type=script&lang=js"

import "./StudentMessagesBlock.vue?vue&type=style&index=0&id=667e362f&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667e362f"]])

export default __exports__